/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigureAdminRolesModal_UserFragmentDoc } from './ConfigureAdminRolesModal.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SearchUserModalQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']>;
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type SearchUserModalQuery = { __typename: 'Query', serviceAdminEligibleUsers: { __typename: 'ServiceAdminEligibleUsersPayload', totalCount: number, users: Array<{ __typename: 'User', id: string, givenName: string, familyName: string, email: string, roles: Array<Types.Role>, serviceAdminRoles: Array<Types.ServiceAdminRole>, customerIds?: Array<string> | null }> } };


export const SearchUserModalDocument = gql`
    query SearchUserModal($search: String, $pageSize: Int, $pageNumber: Int) {
  serviceAdminEligibleUsers(
    search: $search
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    users {
      ...ConfigureAdminRolesModal_user
    }
  }
}
    ${ConfigureAdminRolesModal_UserFragmentDoc}`;

/**
 * __useSearchUserModalQuery__
 *
 * To run a query within a React component, call `useSearchUserModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserModalQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useSearchUserModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUserModalQuery, SearchUserModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUserModalQuery, SearchUserModalQueryVariables>(SearchUserModalDocument, options);
      }
export function useSearchUserModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUserModalQuery, SearchUserModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUserModalQuery, SearchUserModalQueryVariables>(SearchUserModalDocument, options);
        }
export type SearchUserModalQueryHookResult = ReturnType<typeof useSearchUserModalQuery>;
export type SearchUserModalLazyQueryHookResult = ReturnType<typeof useSearchUserModalLazyQuery>;
export type SearchUserModalQueryResult = ApolloReactCommon.QueryResult<SearchUserModalQuery, SearchUserModalQueryVariables>;